module.exports = __webpack_public_path__ + "img/Flag_of_Zimbabwe.7afd358d.svg";